<template>
  <v-dialog v-model="authorityGroupDialogVisible" width="600">
    <customDialog>
      <template v-slot:title>
        {{isUserAuthorityDetail ? t('userInformation') : privilegeGroupData.id != undefined ? t('editAuthGroup') : t('newGroupCreate')}}
        <button id="dialog_exit">
          <img src="@/assets/images/popup_close.png" id="btn_img" @click="authorityGroupDialogVisible = false">
        </button>
      </template>
      <template v-slot:body>
        <v-row class="ma-0 pa-0" justify="center">
          <v-col id="dialog_body" class="ma-0 pa-0" cols="10">
            <v-row v-if="isUserAuthorityDetail == true" class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('name')}} :</v-col>
              <v-col class="ma-0 pa-0" cols="auto">{{userAuthorityDetail.name}}</v-col>
            </v-row>
            <v-row v-if="isUserAuthorityDetail == true" class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('userId')}} :</v-col>
              <v-col class="ma-0 pa-0" cols="auto">{{userAuthorityDetail.userName}}</v-col>
            </v-row>
            <v-row v-if="isUserAuthorityDetail == true" class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('emailAddress')}} :</v-col>
              <v-col class="ma-0 pa-0" cols="auto">{{userAuthorityDetail.mailAddress}}</v-col>
            </v-row>
            <v-row v-if="isUserAuthorityDetail == true" class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto" align-self="center" >{{t('authority')}} :</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-row class="ma-0 pa-0" cols="auto">
                  <v-col class="ma-0 pa-0 mr-2" cols="auto" align-self="center">{{ts('normalUser')}}</v-col>
                  <v-col class="ma-0 pa-0" cols="auto" style="width:10rem;">
                    <v-select class="ma-0 pa-1" v-model="selectedAuthority" placeholder="グループ未設定"
                      :items="privilegeGroupList" dense hide-details outlined
                      dark item-text="name" item-value="id"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <!-- <v-row v-if="isUserAuthorityDetail == true" class="ma-0 pa-0 mb-15 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto" align-self="center" >
                {{t('status')}} :
              </v-col>
              <v-col class="ma-0 pa-0" cols="auto" style="width:10rem;">
                <v-select class="ma-0 pa-1 status_select" v-model="selectedStatus"
                  :items="cameraStatusList" dense hide-details outlined 
                  dark item-text="label" item-value="value"
							  ></v-select>
              </v-col>
            </v-row> -->
            <!-- <v-row v-if="isUserAuthorityDetail == true" class="ma-0 pa-0 mb-15 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto" align-self="center" >
                {{t('deleteAccount')}}
              </v-col>
              <v-col class="ma-0 pa-0" cols="auto" align-self="center">
                <v-btn class="ma-0 pa-0" id="red_btn"
					   		  width="8rem" height="2rem">{{t('delete')}}</v-btn>
              </v-col>
            </v-row> -->

            <v-row v-if="isUserAuthorityDetail != true" class="ma-0 pa-0 mb-15 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto" align-self="center">{{t('authorityGroupName')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <input id="name_input" :placeholder="t('groupNamePlaceholder')" v-model="groupName">
              </v-col>
            </v-row>

						<!-- 설정 시스템 -->
            <v-row class="ma-0 pa-0 user_detail_group"
							v-if="roleNumber != '0' && roleNumber != '1' && roleNumber != '30' &&
								roleNumber != '31' && currentRole != 'main' && currentRole != 'head'">
              {{t('settingSystem')}}
            </v-row>
						<!-- 매장그룹 생성 및 사용자 할당 -->
            <!-- <v-row v-if="currentRole != 'branch' && currentRole != 'private'"  class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('storeGroupCreationAndUserAssignment')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-switch class="ma-0 pa-0" :disabled="disableList.indexOf(accountRole.ADD_STORE_GROUP) != -1" 
                  v-model="accountAuthGroup.ADD_STORE_GROUP" hide-details></v-switch>
              </v-col>
            </v-row> -->
						<!-- 권한그룹에 대한 기능 설정 -->
            <v-row class="ma-0 pa-0 user_detail_list" justify="space-between"
							v-if="roleNumber != '0' && roleNumber != '1' && roleNumber != '30' &&
								roleNumber != '31' && currentRole != 'main' && currentRole != 'head'">
              <v-col class="ma-0 pa-0" cols="auto">{{t('settingFeaturesForPermissionGroups')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-switch class="ma-0 pa-0" :disabled="disableList.indexOf(accountRole.SET_PERMISSIONS_GROUP) != -1" 
                  v-model="accountAuthGroup.SET_PERMISSIONS_GROUP" hide-details></v-switch>
              </v-col>
            </v-row>
						<!-- 지점사용자 권한에 대한 기능 설정 -->
            <!-- <v-row v-if="currentRole != 'branch' && currentRole != 'private'" class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('settingFeaturesForBranchUserPermissions')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-switch class="ma-0 pa-0" :disabled="disableList.indexOf(accountRole.SET_BRANCH_USER) != -1" 
                  v-model="accountAuthGroup.SET_BRANCH_USER" hide-details></v-switch>
              </v-col>
            </v-row> -->

						<!-- 분석 데이터 -->
            <v-row class="ma-0 pa-0 mt-15 user_detail_group"
							v-if="roleNumber != 2 && roleNumber != 3 && roleNumber != 9 &&
								roleNumber != 32 && roleNumber != 33 && roleNumber != 39">
              {{t('analyticalData')}}
            </v-row>
						<!-- 전점포 통계 -->
            <!-- <v-row v-if="currentRole != 'branch' && currentRole != 'private'"  class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('totalOfAllStores')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-switch class="ma-0 pa-0" :disabled="disableList.indexOf(accountRole.GET_TOTAL_STORES) != -1" 
                  v-model="accountAuthGroup.GET_TOTAL_STORES" hide-details></v-switch>
              </v-col>
            </v-row> -->
						<!-- 매장 그룹 -->
            <v-row v-if="currentRole != 'branch' && currentRole != 'private'"  class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('storeGroup')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-switch class="ma-0 pa-0" :disabled="disableList.indexOf(accountRole.GET_STORE_GROUP) != -1" 
                  v-model="accountAuthGroup.GET_STORE_GROUP" hide-details></v-switch>
              </v-col>
            </v-row>
						<!-- 내 점포 -->
						<v-row class="ma-0 pa-0 user_detail_list" justify="space-between"
							v-if="roleNumber == '0' || roleNumber == '1' || roleNumber == '30' ||
								roleNumber == '31'">
              <v-col class="ma-0 pa-0" cols="auto">{{t('ownStore')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-switch class="ma-0 pa-0" 
                  v-model="accountAuthGroup.GET_OWN_STORE" hide-details></v-switch>
              </v-col>
            </v-row>

						<!-- 기능적 표현 -->
            <v-row v-if="currentRole != 'branch' && currentRole != 'private'"  class="ma-0 pa-0 mt-15 user_detail_group">
              {{t('functionalExpression')}}
            </v-row>
						<!-- 대시보드 -->
            <v-row v-if="currentRole != 'branch' && currentRole != 'private'"  class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('dashboard')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-switch class="ma-0 pa-0" :disabled="disableList.indexOf(accountRole.GET_DASHBOARD) != -1" 
                  v-model="accountAuthGroup.GET_DASHBOARD" hide-details></v-switch>
              </v-col>
            </v-row>
						<!-- 매장검색 -->
            <!-- <v-row v-if="currentRole != 'branch' && currentRole != 'private'"  class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('storeSearch')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-switch class="ma-0 pa-0" :disabled="disableList.indexOf(accountRole.SEARCH_STORE) != -1" 
                  v-model="accountAuthGroup.SEARCH_STORE" hide-details></v-switch>
              </v-col>
            </v-row> -->
            <!-- <v-row class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{`ログ`}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-switch class="ma-0 pa-0" v-model="accountAuthGroup.SEARCH_LOG" hide-details></v-switch>
              </v-col>
            </v-row> -->

						<!-- 운영체제 -->
            <v-row class="ma-0 pa-0 mt-15 user_detail_group">
              {{t('operatingSystem')}}
            </v-row>
						<!-- 북마크 만들기 및 알림 -->
            <v-row class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('bookmarkCreationAndNotification')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-switch class="ma-0 pa-0" :disabled="disableList.indexOf(accountRole.ADD_BOOKMARK) != -1"
                  v-model="accountAuthGroup.ADD_BOOKMARK" hide-details></v-switch>
              </v-col>
            </v-row>
						<!-- 클립 만들기 및 알림 -->
            <v-row class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('clipCreationAndNotification')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-switch class="ma-0 pa-0" :disabled="disableList.indexOf(accountRole.ADD_CLIP) != -1"
                  v-model="accountAuthGroup.ADD_CLIP" hide-details></v-switch>
              </v-col>
            </v-row>
						<!-- 태그 설정 -->
            <v-row class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('tagSetting')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-switch class="ma-0 pa-0" :disabled="disableList.indexOf(accountRole.SET_TAG) != -1" 
                  v-model="accountAuthGroup.SET_TAG" hide-details></v-switch>
              </v-col>
            </v-row>
						<!-- 카메라 설정 -->
            <v-row class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('cameraSettings')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-switch class="ma-0 pa-0" :disabled="disableList.indexOf(accountRole.SET_CAMERA) != -1" 
                  v-model="accountAuthGroup.SET_CAMERA" hide-details></v-switch>
              </v-col>
            </v-row>
						<!-- 연결이 끊긴 알림 시간 설정 -->
            <!-- <v-row class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('timeSettingForDisconnectionNotification')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-switch class="ma-0 pa-0" v-model="accountAuthGroup.SET_DISCONNECTION_ALARM" hide-details></v-switch>
              </v-col>
            </v-row> -->
						<!-- 로그아웃 시간 설정 -->
            <v-row class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('logoutTimeSetting')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-switch class="ma-0 pa-0" :disabled="disableList.indexOf(accountRole.SET_LOGOUT_TIME) != -1"
                  v-model="accountAuthGroup.SET_LOGOUT_TIME" hide-details></v-switch>
              </v-col>
            </v-row>
            <!-- <v-row class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{`WEB UIリモート設定`}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-switch class="ma-0 pa-0" hide-details></v-switch>
              </v-col>
            </v-row> -->
						<!-- 매장 지도 편집 -->
            <!-- <v-row class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('storeMapEditing')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-switch class="ma-0 pa-0" hide-details></v-switch>
              </v-col>
            </v-row> -->
						<!-- 녹화 정지 -->
            <v-row class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('stopRecording')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-switch class="ma-0 pa-0" :disabled="disableList.indexOf(accountRole.SET_RECORDING) != -1" 
                  v-model="accountAuthGroup.SET_RECORDING" hide-details></v-switch>
              </v-col>
            </v-row>

						<!-- 자기 매장의 열람계 -->
            <v-row class="ma-0 pa-0 mt-15 user_detail_group">
              {{t('browsingSystem')}}
            </v-row>
						<!-- 라이브 영상 시청, 녹화 재생 -->
            <v-row class="ma-0 pa-0 user_detail_list disabled_div" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('liveVideoViewingRecordingAndPlayback')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-switch class="ma-0 pa-0" disabled
                  v-model="accountAuthGroup.GET_RECORDING" hide-details></v-switch>
              </v-col>
            </v-row>
						<!-- 녹화 데이터 다운로드 -->
            <v-row class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('downloadRecordedData')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto"
								v-if="currentRole == 'private' || currentRole == 'branch'">
                <v-switch class="ma-0 pa-0" :disabled="disableList.indexOf(accountRole.DOWNLOAD_RECORDING) != -1" 
                  v-model="accountAuthGroup.DOWNLOAD_RECORDING" hide-details></v-switch>
              </v-col>
							<v-col class="ma-0 pa-0" cols="auto"
								v-else>
                <v-switch class="ma-0 pa-0" :disabled="disableList.indexOf(accountRole.DOWNLOAD_RECORDING_SUB_BRANCH) != -1" 
                  v-model="accountAuthGroup.DOWNLOAD_RECORDING_SUB_BRANCH" hide-details></v-switch>
              </v-col>
            </v-row>
						<!-- PTZ동작 -->
            <v-row class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('ptzOperation')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto"
                v-if="role === 'main' || role === 'head'">
                <v-switch class="ma-0 pa-0"
                          :disabled="disableList.indexOf(accountRole.SET_PTZ_SUB_BRANCH) != -1"
                          v-model="accountAuthGroup.SET_PTZ_SUB_BRANCH" hide-details></v-switch>
              </v-col>
              <v-col class="ma-0 pa-0" cols="auto"
                     v-else>
                <v-switch class="ma-0 pa-0"
                          :disabled="disableList.indexOf(accountRole.SET_PTZ) != -1"
                          v-model="accountAuthGroup.SET_PTZ" hide-details></v-switch>
              </v-col>
            </v-row>
            <!-- <v-row class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('twoWayCall')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-switch class="ma-0 pa-0" v-model="accountAuthGroup.CALL_TWO_WAY" hide-details></v-switch>
              </v-col>
            </v-row> -->
            <!-- <v-row class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('savedDataCurrentOptionAssumption')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-switch class="ma-0 pa-0" v-model="accountAuthGroup.ADD_SAVED_DATA" hide-details></v-switch>
              </v-col>
            </v-row> -->

						<!-- 종속 지점 검색 시스템 -->
            <!-- <v-row class="ma-0 pa-0 mt-15 user_detail_group">
              {{t('browsingSystemOfSubordinateBranches')}}
            </v-row>
            <v-row class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('liveVideoViewingRecordingAndPlayback')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-switch class="ma-0 pa-0" :disabled="disableList.indexOf(accountRole.GET_RECORDING_SUB_BRANCH) != -1" 
                  v-model="accountAuthGroup.GET_RECORDING_SUB_BRANCH" hide-details></v-switch>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('downloadRecordedData')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-switch class="ma-0 pa-0" :disabled="disableList.indexOf(accountRole.DOWNLOAD_RECORDING_SUB_BRANCH) != -1" 
                  v-model="accountAuthGroup.DOWNLOAD_RECORDING_SUB_BRANCH" hide-details></v-switch>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('ptzOperation')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-switch class="ma-0 pa-0" :disabled="disableList.indexOf(accountRole.SET_PTZ_SUB_BRANCH) != -1" 
                  v-model="accountAuthGroup.SET_PTZ_SUB_BRANCH" hide-details></v-switch>
              </v-col>
            </v-row> -->

            <!-- <v-row class="ma-0 pa-0 mt-15 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('twoWayCall')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-switch class="ma-0 pa-0" v-model="accountAuthGroup.CALL_TWO_WAY_SUB_BRANCH" hide-details></v-switch>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('savedDataCurrentOptionAssumption')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-switch class="ma-0 pa-0" v-model="accountAuthGroup.ADD_SAVED_DATA_SUB_BRANCH" hide-details></v-switch>
              </v-col>
            </v-row> -->
            <!-- <v-row class="ma-0 pa-0 user_detail_group">
              {{t('service')}}
            </v-row>
            <v-row class="ma-0 pa-0 user_detail_list" justify="space-between">
              <v-col class="ma-0 pa-0" cols="auto">{{t('contractPlanSetting')}}</v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <v-switch class="ma-0 pa-0" :disabled="disableList.indexOf(accountRole.SET_CONTRACT) != -1"
                  v-model="accountAuthGroup.SET_CONTRACT" hide-details></v-switch>
              </v-col>
            </v-row> -->
            <v-row class="ma-0 pa-0 mt-15 pb-2 justify-center">
              <v-btn class="ma-0 pa-0 ml-2" id="grey_btn" @click="authorityGroupDialogVisible = false"
                width="10rem" height="2rem">{{t('cancel')}}</v-btn>
              <v-btn v-if="isUserAuthorityDetail == true" class="ma-0 pa-0 ml-2" 
								id="blue_btn" :loading="loading" @click="addAccountAuthGroup"
                width="10rem" height="2rem">{{t('changePermissions')}}</v-btn>
              <v-btn v-else-if="privilegeGroupData.id != undefined" 
								class="ma-0 pa-0 ml-2" id="blue_btn" :loading="loading" 
								@click="patchUserGroupAuthGroup"
                width="10rem" height="2rem">{{t('changePermissions')}}</v-btn>
              <v-btn v-else class="ma-0 pa-0 ml-2" id="blue_btn" :loading="loading" 
								@click="addUserGroupAuthGroup"
                width="10rem" height="2rem">{{t('createPermissions')}}</v-btn>
            </v-row>
          </v-col>
        </v-row>
      </template>
    </customDialog>
  </v-dialog>
</template>
<script>
import mixin from '@/mixin';
import customDialog from '@/components/Modal.vue';
export default {
  props: {
    dialogVisible: Boolean,
    isUserAuthorityDetail: Boolean,
    userAuthorityDetail: Object,
    privilegeGroupList: Array,
    privilegeGroupData: Object,
    isBranch: Boolean,
    edit: String, // 편집 타입
  },
  components: {
    customDialog
  },
  mixins: [mixin.common],
  data: () => ({
    authorityGroupDialogVisible: false,
    role: '',
		cameraStatusList: [
      {label: '利用停止', value: '0'},
      {label: '利用可能', value: '1'},
    ],
    // selectedStatus: '1',
    selectedAuthority: null,
    groupName: '',
    accountAuthGroup: {},
    loading: false,
    accountRole: {},
    disableList: ["0", "1"],
    currentRole: "",
		roleNumber: '',
  }),
  watch: {
    dialogVisible: async function(item) {
      if(item) {
        await this.getAllRoleGroupList();
        if(this.isUserAuthorityDetail === false) {
          this.$vloading.hide();
          this.authorityGroupDialogVisible = item;
          if(this.edit === 'new') {
            this.groupName = '';
          } else {
            if(this.privilegeGroupData.authGroup !== undefined) {
              this.groupName = this.privilegeGroupData.name;
              this.accountAuthGroup = this.privilegeGroupData.authGroup;
            }
          }
        } else {
          if(this.userAuthorityDetail !== undefined) await this.getAccountAuthGroup();
          this.authorityGroupDialogVisible = item;
        }
      }
    },
    authorityGroupDialogVisible: function(item) {
      this.$emit('showGroupDialog', false);
      this.$emit('visible', item);
      // 닫힐때 선택된 권한그룹은 초기화 시켜준다.
      if (item === false) {
        this.selectedAuthority = null;
      }
    },
    privilegeGroupData: function(item) {
      if(item.authGroup !== undefined) {
        this.groupName = item.name;
        this.accountAuthGroup = item.authGroup;
      }
    }
  },
  created() {
    this.role = this.roleCheck(this.$store.getters.getRole);
  },
  mounted() {
		
  },
  methods: {
		ts(t) {
      return this.$t("lang.settings." + t);
    },
    authorityDialogResult() {
      this.$emit('showGroupDialog', true);
    },
    async getAccountAuthGroup() {
      const params = {};
      const umid = this.userAuthorityDetail.umid;
      await this.networkController.getAccountAuthGroup(params, umid)
      .then(async(res) => {
        this.accountAuthGroup = res.data.authGroup;
        this.$vloading.hide();
      }).catch(error => {
        this.$vloading.hide();
      });
    },
		checkEmptyInputValue() {
			if(this.groupName === '' || this.groupName === undefined) {
				this.showToastMessage(this.tmb('requiredGroupName'));
				return true;
			}
			else return false;
		},
    async addAccountAuthGroup() {
			this.loading = true;
      let params = {
        accountRole: this.userAuthorityDetail.role,
        authGroup: this.accountAuthGroup,
        createdDate: '',
        // lastLoginDate: this.userAuthorityDetail.loginAt,
        umid: this.userAuthorityDetail.umid,
        userGroupAuthGroupId: this.selectedAuthority,
      };
      await this.networkController.addAccountAuthGroup(params)
      .then((res) => {
				this.loading = false;
        this.$emit('update', true)
      }).catch(error => {
				this.loading = false;
      });
      this.authorityGroupDialogVisible = false;
    },
    async getAllRoleGroupList() {
      this.$vloading.show();
      let params = {};
			this.roleNumber = this.$store.getters.getRole;
      this.currentRole = this.role;
      let userRole = ""; //일반 사용자
      if(this.isUserAuthorityDetail === false) {
        if(this.role === "private") {
          userRole = "2";
        }
        else if(this.role === "main") {
          userRole = "12";
        }
        else if(this.role === "head") {
          userRole = "22";
        }
        else {
          userRole = "32";
        }
      } else {
        userRole = this.userAuthorityDetail.role;
      }
      await this.networkController.getRoleGroup(params, userRole)
      .then(async(res) => {
        this.accountRole = res.data.accountRole;
        this.makeAuthGroupData(res.data.authGroup);
      }).catch(error => {
        this.$vloading.hide();
      });
    },
    async addUserGroupAuthGroup() {
			if(this.checkEmptyInputValue()) return;
      this.loading = true;
			const role = this.roleCheck(this.$store.getters.getRole);
      let params = {
        unisCustomerCd: this.isBranch === false ? this.$store.getters.getUserunisCustomerCd : this.$route.query.unisCustomerCd,
        accountRole: this.getAccountRole(this.role),
        authGroup: this.accountAuthGroup,
        name: this.groupName,
      };

      if(this.privilegeGroupData.id !== undefined) {
        if(this.isBranch === true) {
          params.accountRole = "32"
        } else {
          if(this.role === "private") {
            params.accountRole = "2";
          }
          else if(this.role === "main") {
            params.accountRole = "12";
          }
          else if(this.role === "head") {
            params.accountRole = "22";
          }
          else {
            params.accountRole = "32";
          }
        }
        params.id = this.privilegeGroupData.id;
      }
      this.networkController.addUserGroupAuthGroup(params)
      .then((res) => {
        this.loading = false;
        this.$emit('update', true)
        this.authorityGroupDialogVisible = false;
      }).catch(error => {
        this.loading = false;
        this.authorityGroupDialogVisible = false;
      });
    },
    getAccountRole(role) {
      if(this.userAuthorityDetail === undefined || this.userAuthorityDetail.role === undefined) {
        if(this.isBranch === true) {
          return "32"
        } else {
          if(role === "private") {
            return "2";
          }
          else if(role === "main") {
            return "12";
          }
          else if(role === "head") {
            return "22";
          }
          else {
            return "32";
          }
        }
      }
    },
    async patchUserGroupAuthGroup() {
			if(this.checkEmptyInputValue()) return;
      this.loading = true;
      let params = {
        accountRole: this.privilegeGroupData.accountRole,
        authGroup: this.accountAuthGroup,
        name: this.groupName,
        unisCustomerCd: this.privilegeGroupData.unisCustomerCd,
        id: this.privilegeGroupData.id,
      };
			let id = this.privilegeGroupData.id;

      //자기 자신이 속한 group의 권한을 변경하는 경우 
      let index = this.privilegeGroupData.accountAuthGroupList.findIndex((item) => item.umid == this.$store.getters.getUmid);
      if(index !== -1) {
        await this.$store.commit('setUserAuthorities', this.accountAuthGroup);
      }
      await this.networkController.patchUserGroupAuthGroup(params, id)
      .then(async(res) => {
        this.loading = false;
        this.$emit('update', true)
        this.authorityGroupDialogVisible = false;
      }).catch(error => {
        this.loading = false;
        this.authorityGroupDialogVisible = false;
      });
    },
    makeAuthGroupData(accountAuthGroup) {
      let obj = Object.entries(accountAuthGroup);
      obj.forEach((item) => {
        if(item[1] === "0") { //변경불가 false
          item[1] = false;
        }
        else if(item[1] === "1") { //변경불가 true
          item[1] = true;
        }
        else if(item[1] === "2") { //변경가능 true
          item[1] = true;
        }
        else { //변경가능 false
          item[1] = false;
        }
      });
      this.accountAuthGroup = Object.fromEntries(obj);
    }
  },
}
</script>

<style lang="scss" scoped>
input, textarea {
  padding-left: 1em;
  color: white;
  background-color: #272727;
  border: 1px solid #4A4A4A;
  border-radius: 3px;
  height: 2.5em;
}
.v-list{
  background: #171921 !important;
	border: 1px solid #4A4A4A;
  padding: 0;
}
::v-deep {
  .v-list-item__content{
    color: white;
  }
  .v-dialog {
    &::-webkit-scrollbar {
      width: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: white;
    }
    &::-webkit-scrollbar-track {
      background-color: #4A4A4A;
    }
  }
  .v-input__slot {
		padding-right: 2px !important;
	}
	.v-input__append-inner {
		margin-top: 16px !important;
		padding-left: 0px !important;
	}
  // Select Box Height 설정
	.v-text-field--outlined > .v-input__control > .v-input__slot {
		min-height: 35px !important;
	}
	.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control {
		height: 35px;
	}
}
#name_input {
  width: 15em;
}
.user_detail_list {
  height: 3rem;
  align-content: center;
  border-bottom: 1px solid #707070;
}
.user_detail_group {
  color: #8B8B8B;
}
.disabled_div {
	pointer-events: none;
  opacity: 0.4;
}
</style>